var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffffe8",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2360 5114 c-321 -29 -617 -112 -905 -253 -652 -320 -1140 -893 -1349 -1584 -74 -243 -101 -437 -101 -722 0 -300 34 -520 120 -783 43 -130 122 -322 133 -322 2 0 70 31 149 70 l144 69 -17 38 c-58 135 -79 190 -109 289 -238 782 -22 1638 560 2219 675 676 1696 846 2550 425 125 -61 315 -177 355 -216 12 -12 1 -14 -83 -14 l-97 0 0 -175 0 -175 323 0 c183 0 337 4 358 10 48 13 104 72 117 121 8 30 2 116 -22 364 -18 179 -34 327 -37 329 -6 6 -333 -25 -340 -33 -4 -3 -2 -42 2 -86 5 -43 8 -83 7 -87 -2 -4 -46 22 -98 59 -330 230 -708 379 -1115 439 -97 14 -455 26 -545 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890 3868 c-366 -176 -668 -323 -672 -326 -4 -4 295 -173 663 -376 653 -359 672 -368 699 -355 149 75 1318 725 1312 731 -4 4 -304 149 -667 323 -363 174 -662 318 -665 320 -3 2 -304 -141 -670 -317z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4712 3600 l-143 -69 17 -38 c129 -292 189 -551 201 -858 33 -875 -459 -1692 -1252 -2080 -589 -288 -1276 -298 -1882 -28 -114 51 -300 158 -385 222 l-49 36 95 3 96 3 0 174 0 175 -322 0 c-194 0 -338 -4 -361 -11 -20 -5 -52 -25 -70 -43 -59 -59 -60 -73 -23 -439 18 -180 35 -329 37 -331 6 -6 333 26 340 33 4 3 2 42 -2 86 -5 43 -8 83 -7 87 2 4 55 -28 118 -71 338 -231 716 -376 1130 -432 126 -18 508 -18 625 0 292 43 548 121 790 240 284 140 469 273 695 500 262 263 440 529 574 856 127 313 181 592 180 945 0 280 -24 463 -95 708 -42 149 -143 403 -158 401 -3 0 -70 -31 -149 -69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3453 2818 l-693 -380 0 -710 c0 -582 2 -709 13 -705 7 3 320 152 695 333 l682 327 0 759 c0 417 -1 758 -2 758 -2 -1 -315 -172 -695 -382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 2437 l0 -753 678 -326 c372 -180 685 -330 695 -334 16 -6 17 32 17 703 l0 709 -684 377 c-376 207 -689 377 -695 377 -8 0 -11 -210 -11 -753z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbo);
export default __webpack_public_path__ + "static/media/fbo.22f53232dd796ee9f3781cd784ae1b2c.svg";
export { ForwardRef as ReactComponent };